import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root 없음");
createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
